import React from 'react';
import cx from 'classnames';
import { Paragraph } from '../../../../Typography';
import styles from '../../EmptyState.module.scss';
const Description = ({ children, className, ...props }) => {
    return (React.createElement(Paragraph, { className: cx(styles.description, className), ...props }, children));
};
export default Description;
